export default {
  fieldsById: {
    desactivationReason: {
      type: `textarea`,
      value: undefined,
      useNameInsteadId: true,
      fullWidth: true,
      showCounter: true,
      useOnChangeInsteadOnBlur: true,
      tooltip: `Este mensaje lo vera el proveedor`,
      label: `Escribe un mensaje al proveedor (máx 200 caracteres)`,
      rules: {
        useFormValue: true,
        required: true,
        min: 1,
        max: 200,
      },
    },
  },
  sections: {
    fieldsIds: [`desactivationReason`],
  },
}
